import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { detailsInfo } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询限制限额详情
// 接口文档：https://cooper.didichuxing.com/docs2/document/2203679762967
export function getDetailInfo(params: { type: string }) {
  return request.get<detailsInfo>(
    `${baseUrl}/sofipo/v0/main/getLimitDetail?type=${params.type}`,
    {},
  );
}
